var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "detailsPageWrap"
  }, [_c('div', {
    staticClass: "detailsPage",
    class: _vm.isVideoPost ? 'videoPostDetail' : ''
  }, [_c('div', [_c('div', {
    staticClass: "uploadPage_toptitle"
  }, [_c('div', {
    staticClass: "uploadPage_toptitlebox"
  }, [_c('van-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.applets_first,
      expression: "!applets_first"
    }],
    staticClass: "uploadPage_back",
    attrs: {
      "name": "arrow-left"
    },
    on: {
      "click": _vm.backClick
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.applets_first,
      expression: "applets_first"
    }],
    staticClass: "tab_home_xcx",
    on: {
      "click": _vm.gohome
    }
  }), _c('van-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: this.$store.state.system == 'android' && _vm.applets != 'xcx' && !_vm.$store.state.isXcx && this.$store.state.isInGame,
      expression: "\n              this.$store.state.system == 'android' &&\n              applets != 'xcx' &&\n              !$store.state.isXcx &&\n              this.$store.state.isInGame\n            "
    }],
    staticClass: "fork",
    attrs: {
      "name": "close"
    },
    on: {
      "click": _vm.closeCommunity
    }
  }), _vm.isVideoPost ? _c('div', {
    staticClass: "top_video_box"
  }, [_vm.$store.state.isInGame && _vm.$store.state.isU3d ? _c('div', {
    staticStyle: {
      "position": "relative",
      "height": "100%"
    },
    on: {
      "click": function ($event) {
        return _vm.goUrl(_vm.user.videos[0].path);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.topPoster
    }
  }), _c('img', {
    staticClass: "marginAuto",
    attrs: {
      "src": require("@/assets/img/rich/t_cover.png"),
      "alt": ""
    }
  })]) : _c('video', {
    ref: "myvideo",
    staticClass: "top_video",
    attrs: {
      "src": _vm.user.videos[0].path,
      "poster": _vm.user.videos[0].path + '.jpg',
      "muted": "",
      "controls": "",
      "controlslist": "nodownload"
    },
    domProps: {
      "muted": true
    }
  })]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.topUserInfo,
      expression: "topUserInfo"
    }],
    staticClass: "detailsPage_top_userInfo"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.memberAvator,
      "alt": ""
    }
  }), _c('p', [_vm._v(_vm._s(_vm.user.memberNickName))])])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.flag,
      expression: "!flag"
    }],
    staticClass: "listPage_emptyicon"
  }, [_c('div', {
    staticClass: "listPage_emptyicon_icon"
  }), _c('div', {
    staticClass: "listPage_emptyicon_text"
  }, [_vm._v("帖子不存在")])]), _c('van-pull-refresh', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.flag,
      expression: "flag"
    }, {
      name: "swipeup",
      rawName: "v-swipeup",
      value: e => _vm.vueTouch('上滑', e),
      expression: "(e) => vueTouch('上滑', e)"
    }],
    attrs: {
      "success-text": "刷新成功"
    },
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: _vm.isLoading,
      callback: function ($$v) {
        _vm.isLoading = $$v;
      },
      expression: "isLoading"
    }
  }, [_c('div', {
    staticClass: "detailsWrap"
  }, [_vm.$store.state.gameType != 5 && _vm.$store.state.gameType != 2 ? _c('div', {
    staticClass: "userInfo"
  }, [_c('div', {
    staticClass: "detailsWrap_userInfo_left",
    on: {
      "click": function ($event) {
        return _vm.goUserPage(_vm.user.memberId);
      }
    }
  }, [_c('div', {
    staticClass: "userInfo_leftbox_imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.memberAvator,
      "alt": ""
    },
    on: {
      "error": function ($event) {
        return _vm.defImg();
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.user.isOfficial == 1 || _vm.user.isOfficial == 2 || _vm.user.memberAuthInfo,
      expression: "\n                    user.isOfficial == 1 ||\n                    user.isOfficial == 2 ||\n                    user.memberAuthInfo\n                  "
    }],
    staticClass: "userInfo_leftbox_img_icon",
    class: _vm.user.memberAuthInfo && _vm.user.isOfficial == 0 ? 'memberAuthInfoFlag' : ''
  })]), _c('div', {
    staticClass: "username memberName"
  }, [_c('div', {
    staticClass: "levelIconbox"
  }, [_c('div', {
    staticClass: "detailsWrap_userInfo_Name"
  }, [_vm._v(" " + _vm._s(_vm.user.memberNickName) + " ")]), _c('levelIcon', {
    attrs: {
      "level": _vm.user.memberLevel
    }
  }), _vm.user.memberAuthInfo && _vm.user.isOfficial != 1 && _vm.user.isOfficial != 2 && _vm.$store.state.gameType != 2 && _vm.$store.state.gameType != 5 ? _c('div', {
    staticClass: "auth_icon"
  }, [_vm._v(" " + _vm._s(_vm.user.memberAuthInfo) + " ")]) : _vm._e()], 1), _c('div', {
    staticClass: "detailsWrap_userInfo_left_time"
  }, [_vm._v(" " + _vm._s(_vm.user.createTime) + " · " + _vm._s(_vm.user.viewCount) + "浏览 ")])])]), _c('div', {
    staticClass: "detailsWrap_userInfo_right"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$store.state.memberId != _vm.user.memberId,
      expression: "$store.state.memberId != user.memberId"
    }],
    staticClass: "reply_item_con_top_btn",
    class: _vm.user.isFans == 0 ? 'reply_item_con_top_btn' : 'reply_item_con_top_alreadybtn',
    on: {
      "click": function ($event) {
        return _vm.focusClick();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.user.isFans == 0 ? '+关注' : '已关注') + " ")]), _c('div', {
    staticClass: "eventwrap"
  }, [_c('div', {
    staticClass: "details_comments_top_extension",
    on: {
      "click": function ($event) {
        return _vm.vanActionFlag(1);
      }
    }
  }, [_vm._v(" ... ")])])])]) : _vm._e(), _c('div', {
    class: _vm.user.isOfficial == 1 ? 'publishedContent offical-publishedContent' : 'publishedContent'
  }, [_c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.user.title !== '',
      expression: "user.title !== ''"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.isOfficial == 1 || _vm.user.isOfficial == 2) && _vm.$store.state.gameType != 5 && _vm.$store.state.gameType != 2,
      expression: "\n                  (user.isOfficial == 1 || user.isOfficial == 2) &&\n                  $store.state.gameType != 5 &&\n                  $store.state.gameType != 2\n                "
    }],
    staticClass: "publishedContent_spanicon"
  }, [_vm._v(_vm._s(_vm.user.isOfficial == 1 ? '官方' : '百科'))]), _c('span', {}, [_vm._v(_vm._s(_vm.user.title))])]), _c('div', {
    staticClass: "detailsPage_topicTime"
  }, [_c('div', {
    staticClass: "detailsPage_topic"
  }, _vm._l(_vm.user.subjects, function (item) {
    return _c('p', {
      key: item.id,
      on: {
        "click": function ($event) {
          return _vm.toHotPage(item);
        }
      }
    }, [_vm._v(" #" + _vm._s(item.subjectName) + " ")]);
  }), 0)]), _c(_vm.dynamicComponent, {
    tag: "component"
  }), _vm.user.source !== 'userRichText' ? _c('div', {
    class: _vm.typographyImg
  }, _vm._l(_vm.imgList, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "card_publishedContent_imgbox",
      class: _vm.imgCross,
      on: {
        "click": _vm.imgClick
      }
    }, [_c('img', {
      attrs: {
        "preview": item.class,
        "src": item.path,
        "alt": ""
      }
    })]);
  }), 0) : _vm._e()], 1), _vm.user.partitionName && _vm.$store.state.gameType != 5 && _vm.$store.state.gameType != 2 ? _c('span', {
    staticClass: "detailsPage_partitionName",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toPartition(_vm.user);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.user.partitionName) + " ")]) : _vm._e(), _vm.$store.state.gameType != 5 && _vm.$store.state.gameType != 2 ? _c('div', {
    staticClass: "detailsPage_goodbox"
  }, [_c('div', {
    staticClass: "detailsPage_goodbox_imgbox"
  }, _vm._l(_vm.user.likeMemberAvators, function (item) {
    return _c('img', {
      key: item,
      attrs: {
        "src": item
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.goGoodList(_vm.user.id);
        },
        "error": function ($event) {
          return _vm.defImg();
        }
      }
    });
  }), 0), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.user.goodNum != 0,
      expression: "user.goodNum != 0"
    }],
    staticClass: "detailsPage_goodbox_text"
  }, [_vm._v(" 有" + _vm._s(_vm.user.goodNum) + "人赞过 ")])]) : _vm._e(), _c('div', {
    staticClass: "detailsWrap_userInfo_left_time"
  }, [_vm._v(" 發布於" + _vm._s(_vm.user.createTime) + " ")]), _vm.$store.state.gameType != 5 && _vm.$store.state.gameType != 2 ? _c('div', {
    staticClass: "detailsPage_operation"
  }, [_c('div', {
    staticClass: "goodJob",
    on: {
      "click": _vm.likeClick
    }
  }, [_c('div', {
    ref: "details_lickbtn",
    staticClass: "card_lickbtn",
    class: _vm.user.isLike ? 'publicAction_curgoodicon' : 'publicAction_goodicon'
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.user.goodNum > 0,
      expression: "user.goodNum > 0"
    }],
    staticClass: "detailsPage_operation_num"
  }, [_vm._v(" " + _vm._s(_vm.user.goodNum) + " ")])]), _c('p', {
    staticClass: "operation_step",
    class: _vm.user.isBad ? 'operation_stepcur' : '',
    on: {
      "click": _vm.badClick
    }
  }, [_c('span', {
    staticClass: "operation_step_icon"
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.applets != 'xcx',
      expression: "applets != 'xcx'"
    }],
    staticClass: "operation_forwarding",
    on: {
      "click": _vm.getShare
    }
  }, [_c('span', {
    staticClass: "operation_forwarding_icon"
  })]), _c('p', {
    staticClass: "operation_collection",
    on: {
      "click": _vm.favor
    }
  }, [_c('span', {
    staticClass: "operation_collection_icon",
    class: _vm.user.isFavor ? 'operation_collectioncur' : ''
  })])]) : _vm._e()]), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "select": _vm.onSelect,
      "cancel": _vm.onCancel
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions_complaints,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "select": _vm.onSelect_complaints,
      "cancel": _vm.onCancel
    },
    model: {
      value: _vm.show_complaints,
      callback: function ($$v) {
        _vm.show_complaints = $$v;
      },
      expression: "show_complaints"
    }
  }), _vm.$store.state.gameType != 5 && _vm.$store.state.gameType != 2 ? _c('div', {
    staticClass: "messageWrap pageCommon"
  }, [_c('div', {
    staticClass: "detailsPage_messageTop"
  }, [_c('p', [_c('span', [_vm._v("回复")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.user.commentNum != 0,
      expression: "user.commentNum != 0"
    }],
    staticClass: "replayNum"
  }, [_vm._v(_vm._s(_vm.user.commentNum))])]), _c('div', {
    staticClass: "sort_btn"
  }, [_c('span', {
    style: _vm.sortTypeNum == 0 ? '' : 'color:#cecece',
    on: {
      "click": function ($event) {
        return _vm.tabSort(0);
      }
    }
  }, [_vm._v("最早")]), _c('span', [_vm._v("｜")]), _c('span', {
    style: _vm.sortTypeNum == 1 ? '' : 'color:#cecece',
    on: {
      "click": function ($event) {
        return _vm.tabSort(1);
      }
    }
  }, [_vm._v("最新")])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commentList.length != 0,
      expression: "commentList.length != 0"
    }],
    staticClass: "detailsPage_messageWrap_con"
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.msgFinished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.msgOnLoad
    },
    model: {
      value: _vm.msgLoading,
      callback: function ($$v) {
        _vm.msgLoading = $$v;
      },
      expression: "msgLoading"
    }
  }, [_c('label', {
    attrs: {
      "for": "replyCon"
    }
  }, _vm._l(_vm.commentList, function (item) {
    return _c('message', {
      key: item.id,
      ref: "message",
      refInFor: true,
      attrs: {
        "commentListData": item,
        "messagereplyFlag": _vm.messagereplyFlag,
        "detailId": _vm.detailId
      },
      on: {
        "vanActionFlag": _vm.vanActionFlag,
        "goUserPage": _vm.goUserPage,
        "inputFocus": _vm.getFocus,
        "allReplyChang": _vm.allReplyChang,
        "imgClick": _vm.imgClick
      }
    });
  }), 1)])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.user.commentNum == 0,
      expression: "user.commentNum == 0"
    }],
    staticClass: "detailsPage_messageWrap_word"
  }, [_c('span', [_vm._v(_vm._s(this.shareData.canReply == 0 ? '快来發布你的评论吧~' : ''))])])]) : _vm._e()], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.mongoliaFlag,
      expression: "mongoliaFlag"
    }],
    staticClass: "msgWrapbox",
    on: {
      "click": function ($event) {
        return _vm.inputblur('remove');
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.flag && _vm.$store.state.gameType != 5 && _vm.$store.state.gameType != 2,
      expression: "\n          flag && $store.state.gameType != 5 && $store.state.gameType != 2\n        "
    }],
    staticClass: "detailsPage_bottombox"
  }, [_c('div', {
    staticClass: "msgWrap"
  }, [_c('div', {
    staticClass: "msgWrap_topbox"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.bottomFlag,
      expression: "bottomFlag"
    }],
    staticClass: "msgWrap_bottombox"
  }, [_c('label', {
    attrs: {
      "for": "replyCon"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.postingFlag,
      expression: "postingFlag"
    }],
    staticClass: "msgCon",
    on: {
      "click": function ($event) {
        return _vm.getFocus('imgBtn');
      }
    }
  }, [_vm._v(" " + _vm._s(this.shareData.canReply == 0 ? '说点什么...' : '已关闭回复') + " ")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.postingFlag,
      expression: "!postingFlag"
    }],
    staticClass: "msgCon",
    on: {
      "click": function ($event) {
        return _vm.getFocus('imgBtn');
      }
    }
  }, [_vm._v(" " + _vm._s(this.postingFlag ? '说点什么...' : '功能维护中，暂不支持回复') + " ")])]), _c('div', {
    staticClass: "msgWrap_topbox_iconbox"
  }, [_c('div', {
    staticClass: "commentsWrap",
    on: {
      "click": _vm.toMsgList
    }
  }, [_c('p'), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.user.commentNum > 0,
      expression: "user.commentNum > 0"
    }]
  }, [_vm._v(_vm._s(_vm.user.commentNum))])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.applets != 'xcx',
      expression: "applets != 'xcx'"
    }],
    staticClass: "msgWrap_topbox_forwardicon",
    on: {
      "click": _vm.getShare
    }
  }), _c('p', {
    staticClass: "msgWrap_topbox_collectionicon",
    class: _vm.user.isFavor ? 'operation_collectioncur' : '',
    on: {
      "click": _vm.favor
    }
  })])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.bottomFlag,
      expression: "!bottomFlag"
    }],
    staticClass: "msgWrap_bottombox2",
    class: _vm.emojiFlag && _vm.$padFalg == 'other' ? 'msgWrap_bottombox2_emjoycur' : ''
  }, [_c('div', {
    staticClass: "msgWrap_bottombox2_top"
  }, [_c('div', [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.msgToOtherImg,
      expression: "msgToOtherImg"
    }],
    attrs: {
      "src": _vm.msgToOtherImg,
      "alt": ""
    },
    on: {
      "error": function ($event) {
        return _vm.defImg();
      }
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.msgTo)
    }
  })])]), _c('div', {
    staticClass: "msgWrap_bottombox2_topbox",
    class: _vm.bigmsgWrap
  }, [_c('van-field', {
    ref: "inpIngCon",
    staticClass: "msgCon",
    attrs: {
      "placeholder": "说点什么...",
      "id": "replyCon",
      "maxlength": "1000",
      "rows": "2",
      "autosize": "",
      "label": "",
      "type": "textarea",
      "show-word-limit": ""
    },
    on: {
      "focus": _vm.inputFocus,
      "blur": _vm.inputonblur
    },
    model: {
      value: _vm.replyValue,
      callback: function ($$v) {
        _vm.replyValue = $$v;
      },
      expression: "replyValue"
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.msgWrapImg,
      expression: "msgWrapImg"
    }],
    staticClass: "imglist"
  }, [_c('span', {
    staticClass: "remove_btn",
    on: {
      "click": _vm.removeFile
    }
  }), _c('img', {
    attrs: {
      "preview": 999,
      "src": _vm.msgWrapImg,
      "large": _vm.msgWrapImg
    },
    on: {
      "error": function ($event) {
        return _vm.defImg();
      }
    }
  })])], 1), _c('div', {
    staticClass: "msgWrap_bottombox2_bottom"
  }, [_c('div', {
    staticClass: "msgWrap_bottombox2_bottom_left"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "msgWrap_bottombox2_bottom_left_lefticon"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.msgWrapImg && !_vm.msgImgShow,
      expression: "!msgWrapImg && !msgImgShow"
    }],
    staticClass: "msgWrap_bottombox2_bottom_left_righticon"
  }, [_c('input', {
    ref: "detailsPage_addimg3",
    staticClass: "file-btn",
    attrs: {
      "type": _vm.file1,
      "accept": "image/*"
    },
    on: {
      "change": function ($event) {
        return _vm.addFile($event);
      }
    }
  })]), _c('div', {
    staticClass: "uploadPage_bottom_expression",
    class: _vm.emojiFlag ? 'uploadPage_bottom_expressioncur' : '',
    on: {
      "mousedown": _vm.emojiClick
    }
  })]), _c('div', {
    staticClass: "details_input_text",
    class: [_vm.replyValue == '' && _vm.msgWrapImg == '' ? 'ash' : '', !_vm.postingFlag ? 'ash' : ''],
    on: {
      "click": function ($event) {
        return _vm.submit(1);
      }
    }
  }, [_vm._v(" 發布 ")])]), _vm.emojiFlag && _vm.$padFalg == 'other' ? _c('emjoy', {
    ref: "emjoy",
    on: {
      "pushvalue": _vm.pushvalue,
      "deleteClick": _vm.deleteClick
    }
  }) : _vm._e(), _vm.emojiFlag && _vm.$padFalg != 'other' ? _c('div', {
    staticClass: "pad_emjoy",
    class: !_vm.msgImgShow ? 'pad_emjoy_level1' : 'pad_emjoy_level2'
  }, [_c('div', {
    staticClass: "pad_emjoybox"
  }, [_c('emjoy', {
    ref: "emjoy",
    on: {
      "pushvalue": _vm.pushvalue,
      "deleteClick": _vm.deleteClick
    }
  })], 1)]) : _vm._e()], 1)])])]), _c('van-action-sheet', {
    attrs: {
      "title": "分享到",
      "round": false
    },
    model: {
      value: _vm.shareShow,
      callback: function ($$v) {
        _vm.shareShow = $$v;
      },
      expression: "shareShow"
    }
  }, [_c('shareBounced', {
    staticClass: "content",
    attrs: {
      "shareData": _vm.shareData
    },
    on: {
      "shareShowFlag": _vm.shareShowFlag
    }
  })], 1), _vm.largerFlag ? _c('largerVersion', {
    attrs: {
      "largerImgList": _vm.largerImgList,
      "currindex": _vm.imgcurrindex
    },
    on: {
      "imgClick": _vm.imgClick
    }
  }) : _vm._e()], 1), _vm.allReplyFlag ? _c('div', {
    staticClass: "allReplyListbox"
  }, [_c('allReplyList', {
    attrs: {
      "allReplyListId": _vm.allReplyListId,
      "detailId": _vm.detailId,
      "canReply": _vm.shareData.canReply,
      "postsPosterId": _vm.postsPosterId
    },
    on: {
      "allReplyChang": _vm.allReplyChang,
      "vanActionFlag": _vm.vanActionFlag
    }
  })], 1) : _vm._e()]), _vm.$padFalg != 'other' ? _c('sideRight') : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loadingFlag,
      expression: "loadingFlag"
    }],
    staticClass: "loading_box"
  }, [_c('van-loading', {
    attrs: {
      "type": "spinner",
      "color": "#1989fa"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };